import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'src/app/shared/shared.module';
import {DefaultFilterComponent} from './default-filter.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import {IconsModule} from '../../icons/icons.module';


@NgModule({
  declarations: [
    DefaultFilterComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatTooltipModule,
    MatMenuModule,
    IconsModule
  ],
  exports: [
    DefaultFilterComponent
  ]
})
export class DefaultFilterModule {
}
